import React, { FC } from 'react';
import cx from 'classnames';
import RequestForm from '../RequestForm';

import './styles.scss';
import { detectDevice } from '../../../utils';

type RequestFormContainerPropsTypes = {
  onClose?: () => void;
  token?: string;
  isShow: boolean;
};

const RequestFormContainer: FC<RequestFormContainerPropsTypes> = ({ onClose, token, isShow }) => {
  const { isMobile } = detectDevice();
  return (
    <div
      className={cx('clf-contact-form__container', {
        'clf-contact-form__container--hide': !isShow,
        'clf-contact-form__container--mobile': isMobile,
        'clf-contact-form__container--desktop': !isMobile,
      })}
    >
      {isMobile && (
        <div className="container__btn-back" onClick={onClose}>
          <i className="icon-menu_close_big_24x24"></i>
        </div>
      )}
      <div
        className={cx({
          'container__content-form': isMobile,
        })}
      >
        <RequestForm onFinishSubmit={onClose} token={token} />
      </div>
    </div>
  );
};

export default React.memo(RequestFormContainer);
